// extracted by mini-css-extract-plugin
export default {"Choice":"Choice_Choice__dYS7t"};